import * as React from "react";
const SvgFiBrandsMicrosoftEdge = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-microsoft-edge_svg__a)">
      <path d="m12.582 0 .114.001c3.07.027 6.124 1.086 8.376 2.905 2.38 1.923 3.692 4.533 3.692 7.348 0 2.951-2.993 5.352-6.671 5.352a8 8 0 0 1-2.664-.444.69.69 0 0 1-.453-.483.68.68 0 0 1 .174-.645c.582-.614.903-1.41.903-2.241 0-.798-.323-1.645-.646-2.372a7.3 7.3 0 0 0-1.52-2.228C12.497 5.824 10.594 5.13 8.23 5.13s-5.568.566-7.4 3.26l-.02.028C2.328 3.548 7.04 0 12.583 0" />
      <path d="M3.795 20.51C1.472 18.26.208 15.278.238 12.108c.004-.07.074-1.198.75-2.442.205-.375.45-.732.73-1.06C2.953 7.159 4.83 6.442 6.733 6.24c1.883-.2 3.908-.044 5.544.95l.005.004A6.3 6.3 0 0 1 14.43 9.43l.002.003a3.57 3.57 0 0 0-1.95-.554c-.56.006-1.097.174-1.61.374-1.633.639-2.905 1.827-3.692 3.454-.77 1.593-.991 3.463-.625 5.266.373 1.83 1.343 3.452 2.733 4.565.366.294.765.555 1.183.776a8.3 8.3 0 0 0 1.724.672q.02.007.04.01c-3.194-.066-6.182-1.3-8.44-3.486" />
      <path d="M23.351 18.496c-1.713 2.606-4.477 4.5-7.586 5.198q-.508.023-1.014 0c-1.33-.065-2.656-.397-3.798-1.065a7 7 0 0 1-.816-.56c-1.277-1.024-2.17-2.519-2.514-4.21-.342-1.678-.136-3.414.577-4.89.28-.58.644-1.124 1.085-1.602q.245-.265.52-.499a3.3 3.3 0 0 0-.316 1.471c.04 1.938.999 3.751 2.7 5.106 1.687 1.344 3.917 2.085 6.279 2.085 1.703 0 3.36-.39 4.793-1.128.012-.006.045-.023.082.014.036.037.015.068.008.08" />
    </g>
    <defs>
      <clipPath id="fi-brands-microsoft-edge_svg__a">
        <path fill="#fff" d="M0 0h25v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsMicrosoftEdge;
